export default{
  "common.mode.auto": "स्वतः उत्पादन र स्वतः उपयोग",
  "common.mode.economy": "आर्थिक मोड",
  "common.mode.exigency": "आपतकालीन मोड",
  
  "common.grid": "पावर ग्रिड",
  "common.evChargers": "चार्जिंग स्टेशनहरू",
  "common.evCharger": "चार्जिंग स्टेशन",
  "common.pv": "सौर्य",
  "common.inverter": "इन्भर्टर",
  "common.pcs": "इन्भर्टर+ब्याट्री",
  "common.terminal": "टर्मिनल उपकरण",
  "common.airc": "एयर कन्डिशनर",
  "common.engine": "इन्जिन",
  "common.battery": "ब्याट्री",
  "common.metter": "बिजुली मीटर",
  "common.other": "अन्य",
  "common.power": "पावर",
  "common.powerTotal": "कुल पावर",
  "common.voltage": "भोल्टेज",
  "common.electricity": "बिजुली",
  "common.current": "करेन्ट",
  "common.homeUsage": "घरको कुल लोड",
  "common.battery.power": "ब्याट्री पावर",

  "common.noDataAvailable": "अहिले कुनै डाटा उपलब्ध छैन~",
  "common.tips": "सुझाव",
  "common.reset": "रीसेट",
  "common.currencyUnit": "¥",
  "common.submiting": "पेस गर्दै, कृपया पर्खनुहोस्...",
  "common.close": "बन्द गर्नुहोस्",
  "common.from": "बाट",
  "common.useIn": "प्रयोग गर्न",
  "common.energyPercent": "ऊर्जा प्रवाह प्रतिशत",
  "common.dataFlow": "डाटा प्रवाह",
  "common.getDataIng": "डाटा प्राप्त गर्दै, कृपया पर्खनुहोस्...",
  "common.pageLoading": "पृष्ठ सामग्री लोड हुँदैछ, कृपया पर्खनुहोस्...",
  "common.reseting": "पृष्ठ सामग्री रिसेट हुँदैछ, कृपया पर्खनुहोस्...",
  "common.save": "सुरक्षित गर्नुहोस्",
  "common.onlyNumberTips": "मात्र नम्बर भर्नुहोस्",
  "common.offline": "अफलाइन",
  "common.online": "अनलाइन",
  "common.fault": "त्रुटि",
  "common.charge": "चार्ज",
  "common.discharge": "डिस्चार्ज",
  "common.buy": "किन्नुहोस्",
  "common.sell": "बेच्नुहोस्",
  "common.loadingInfo": "लोड हुँदैछ, कृपया पर्खनुहोस्...",

  "common.moreFeatures": "थप विशेषताहरू",
  "common.confirm": "पुष्टि गर्नुहोस्",
  "common.saveing": "सुरक्षित गर्दै, कृपया पर्खनुहोस्...",
  "common.searchPlacholder": "कृपया खोज कीवर्ड भर्नुहोस्",
  "common.iSee": "मैले बुझें",
  "common.pageErrorTips1": "ओह, वेबपृष्ठमा त्रुटि भयो~",
  "common.pageErrorTips2": "कृपया रिफ्रेस गर्न प्रयास गर्नुहोस्, वा ग्राहक सेवासँग सम्पर्क गर्नुहोस्~",
  "common.refresh": "रिफ्रेस गर्नुहोस्",
  "common.backToHome": "गृहपृष्ठमा फर्कनुहोस्",
  "common.checkTips": "जाँच गर्दै, कृपया पर्खनुहोस्...",
  "common.back": "फर्कनुहोस्",
  "common.cancel": "रद्द गर्नुहोस्",
  "common.optional": "वैकल्पिक",
  "common.required": "आवश्यक",
  "common.status": "स्थिति",
  "common.statusNoDelete": "मेटिएको छैन",
  "common.statusDelete": "मेटिएको छ",
  "common.submit": "पेश गर्नुहोस्",
  "common.disable": "अक्षम गर्नुहोस्",
  "common.enable": "सक्षम गर्नुहोस्",
  "common.year": "वर्ष",
  "common.month": "महिना",
  "common.day": "दिन",
  "common.version": "संस्करण नं.:",
  "common.backHome": " गृहपृष्ठमा फर्कनुहोस्",
  "common.backHomeSorry": " माफ गर्नुहोस्, पृष्ठ बाटो हराएको छ",
  "common.requestTips1": "डाटा प्रशोधन हुँदैछ, कृपया दोहोर्याउनुहोस्",
  "common.requestTips2": "सिस्टम सूचना",
  "common.requestTips3": "लगइन स्थिति म्याद सकिएको छ, कृपया फेरी लगइन गर्नुहोस्",
  "common.requestTips4": "फेरी लगइन गर्नुहोस्",
  "common.requestTips5": "अमान्य सत्र, वा सत्र म्याद सकिएको छ, कृपया फेरी लगइन गर्नुहोस्।",
  "common.requestTips6": "सर्भर त्रुटि, कृपया पछि फेरि प्रयास गर्नुहोस्.",
  "common.requestTips7": "सिस्टम इन्टरफेस अनुरोध समय सकियो",
  "common.requestTips8": "सिस्टम इन्टरफेस",
  "common.requestTips9": "त्रुटि",
  "common.iknow": "मैले बुझें",
  "common.logoutSuccess": "लगआउट सफल भयो",

  "common.knowMore.title": "थप जान्न चाहनुहुन्छ भने, उत्तर ऊर्जा सम्पर्क गर्नुहोस्",
  "common.knowMore.email": "इमेल सम्पर्क",
  "common.knowMore.phone": "फोन सम्पर्क",
  "common.knowMore.wechat": "वेच्याट सम्पर्क",
  "common.knowMore.website": "आधिकारिक वेबसाइट",
  "common.knowMore.address": "सम्पर्क ठेगाना",
  "common.knowMore.addressDetail": "क्वाङतुङ प्रान्त ह्वाङचिआङ शहर ह्वाङजिङखेंग छिंगहो रोड ८ नं. ५ भवन १२०५ कोठा, १३०१ कोठा",

  "common.localConnection": "स्थानिय जडान",
  "common.operateInApp": "कृपया एपमा सञ्चालन गर्नुहोस्!",

  "common.enbleStaus": "सक्षम स्थिति",
  "common.battery.status": "चार्ज वा डिस्चार्ज छैन",

  "account.forgetThePassword": "पासवर्ड बिर्सनुभयो",
  "account.logInDirectly": "सिधा लगइनमा जानुहोस्",
  "account.tips1": "पृष्ठ रिडाइरेक्ट हुँदैछ, कृपया पर्खनुहोस्...",
  "account.tips2": "कृपया पहिले प्रयोगकर्ता निर्देशनहरू पढ्नुहोस् र स्वीकार गर्नुहोस्!",
  "account.autoLogin": "स्वत: लगइन",
  "account.userLogin": "प्रयोगकर्ता लगइन",
  "account.registerTips": "अझै खाता छैन? यहाँ क्लिक गरेर दर्ता गर्नुहोस्",
  "account.userEmail": "प्रयोगकर्ता नाम/इमेल",
  "account.userEmailTips": "कृपया प्रयोगकर्ता नाम/इमेल भर्नुहोस्",
  "account.password": "पासवर्ड",
  "account.passwordTips": "कृपया पासवर्ड भर्नुहोस्",
  "account.submit": "पेश गर्नुहोस्",
  "account.submitTips": "पेश गर्दै, कृपया पर्खनुहोस्...",
  "account.otherLoginTips": "वा अन्य लगइन विधि चयन गर्नुहोस्",
  "account.userRegistration": "प्रयोगकर्ता दर्ता",
  "account.userName": "प्रयोगकर्ता नाम",
  "account.userNameTips": "कृपया प्रयोगकर्ता नाम भर्नुहोस्",
  "account.emailTips1": "कृपया इमेल ठेगाना भर्नुहोस्",
  "account.emailTips2": "इमेल ठेगाना ढाँचा गलत छ",
  "account.phone": "फोन नम्बर",
  "account.phoneTips1": "कृपया फोन नम्बर भर्नुहोस्",
  "account.phoneTips2": "फोन नम्बर गलत छ",
  "account.phoneTips3": "कृपया फोन नम्बर भर्नुहोस्",
  "account.passwordTips1": "कृपया ६-३० अंकको पासवर्ड भर्नुहोस्",
  "account.passwordTips2": "पासवर्ड ढाँचा गलत छ, पासवर्ड अंग्रेजी अंक र अण्डरस्कोर हाइफन डट स्वतन्त्र रूपमा बनेको हुनुपर्छ, लम्बाइ ६-१२ अंक",
  "account.passwordTips3": "दुई पटक भरेको पासवर्ड मेल खाँदैन, कृपया जाँच गर्नुहोस् र फेरी भर्नुहोस्!",
  "account.passwordTips4": "कृपया पासवर्ड भर्नुहोस्, पासवर्ड अंग्रेजी अंक र अण्डरस्कोर हाइफन डट स्वतन्त्र रूपमा बनेको हुनुपर्छ",
  "account.passwordTips5": "पासवर्ड पुष्टि गर्नुहोस्",
  "account.passwordTips6": "कृपया पासवर्ड पुष्टि गर्नुहोस्",
  "account.passwordTips7": "दुई पटक भरेको पासवर्ड मेल खाँदैन, कृपया जाँच गर्नुहोस् र फेरी भर्नुहोस्!",
  "account.passwordTips8": "कृपया पासवर्ड पुष्टि गर्नुहोस्",
  "account.passwordTips9": "बधाई छ, तपाइँको दर्ता सफल भयो!",
  "account.passwordTips10": "तपाइँको प्रयोगकर्ता नाम हो:",
  "account.emailIs": "इमेल हो:",
  "account.goToLoginPage": "सेकेन्डपछि स्वत: लगइन पृष्ठमा रिडाइरेक्ट हुनेछ",
  "account.goLogin": "लगइनमा जानुहोस्",
  "account.goRegister": "दर्ता गर्नुहोस्",
  "account.loginSuccess": "लगइन सफल भयो",
  "account.email": "इमेल",
  "account.sologn": "तपाइँको लागि विशेष रूपमा तयार गरिएको ऊर्जा समाधानहरू",
  "account.pleaseAgree": "मैले पढें र स्वीकार गर्छु",
  "userAgreement.privacyPolicy": "गोपनीयता नीति",

  "account.code": "सत्यापन कोड",
  "account.codeTips": "कृपया सत्यापन कोड भर्नुहोस्",
  "account.codeTips2": "सत्यापन कोड गलत छ",

    "account.inviteCodeTips": "कृपया निमन्त्रणा कोड प्रविष्ट गर्नुहोस्",
    "account.inviteCodeHint": "निमन्त्रणा कोड प्राप्त गर्न कृपया स्थापनाकर्ता वा सञ्चालन तथा मर्मत कर्मचारीलाई सम्पर्क गर्नुहोस्",
  "account.modifyPasswordByAccount": "खाता द्वारा पासवर्ड परिवर्तन गर्नुहोस्",
  "account.modifyPasswordByEmail": "इमेल द्वारा पासवर्ड परिवर्तन गर्नुहोस्",
  "account.getPasswordByAccount": "खाता द्वारा पासवर्ड पुन: प्राप्त गर्नुहोस्",
  "account.getPasswordByEmail": "इमेल द्वारा पासवर्ड पुन: प्राप्त गर्नुहोस्",

  "account.sendEmailTips": "सत्यापन कोड इमेलमा पठाइएको छ, कृपया इमेल जाँच गर्नुहोस्",
  "account.name": "खाता नाम",
  "account.newPassword": "नयाँ पासवर्ड",
  "account.confirmNewPassword": "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
  "account.nameTips": "कृपया खाता नाम भर्नुहोस्",
  "account.passwordModifySuccess": "पासवर्ड परिवर्तन सफल भयो",
  "account.emailCode": "इमेल सत्यापन कोड",
  "account.emailCodeTips": "कृपया इमेल सत्यापन कोड भर्नुहोस्",
  "account.emailCodeTips2": "इमेल सत्यापन कोड गलत छ",
  "account.emailModifySuccess": "पासवर्ड परिवर्तन सफल भयो",
  "account.passworTips1": "तपाइँको पासवर्ड सफलतापूर्वक रिसेट भयो!",
  "account.passwordTips11": "कृपया पासवर्ड पुष्टि गर्नुहोस्",
  "account.passwordTips12": "कृपया नयाँ पासवर्ड भर्नुहोस्",
  "account.nickname": "प्रयोगकर्ता उपनाम",
  "account.modifyNickname": "प्रयोगकर्ता उपनाम परिवर्तन गर्नुहोस्",
  "account.modifyNicknameSuccess": "प्रयोगकर्ता उपनाम परिवर्तन सफल भयो!",
  "account.nicknameTips": "कृपया प्रयोगकर्ता उपनाम भर्नुहोस्",
  "account.nicknameError": "प्रयोगकर्ता उपनाम परिवर्तन असफल भयो!",

  "account.login": "लगइन गर्नुहोस्",
  "account.quickRegister": "द्रुत दर्ता",
  "account.sendCode": "कोड पठाउनुहोस्",
  "account.sendTips": "सेकेन्डपछि फेरी पठाउन सकिन्छ",
  "account.sendEmailIng": "इमेल पठाउँदै, कृपया पर्खनुहोस्...",
  "account.emailNotEmpty": "इमेल ठेगाना खाली हुनुहुन्न",
  "account.registerAccount": "खाता दर्ता गर्नुहोस्",
  "account.registerWelcome": "SusprSafe मा स्वागत छ",
  "account.usernameLimit": "प्रयोगकर्ता नाम केवल अक्षरले सुरु हुनुपर्छ, र केवल अक्षर, अंक, अण्डरस्कोर समावेश गर्न सकिन्छ, लम्बाइ ५-१५ अंकको बीचमा हुनुपर्छ",

  "copyright.desc2": "वेबसाइट इन्सेप्सन जानकारी: युएइसीपीआईसी 2021169764 नं.",

  "editUserInfo.editUserInformation": "प्रयोगकर्ता जानकारी सम्पादन गर्नुहोस्",
  "editUserInfo.modifyUsername": "प्रयोगकर्ता नाम परिवर्तन गर्नुहोस्",
  "editUserInfo.changePictures": "प्रोफाइल तस्वीर परिवर्तन गर्नुहोस्",
  "editUserInfo.savePicturesSuccess": "प्रयोगकर्ता प्रोफाइल तस्वीर सुरक्षित गर्न सफल भयो",
  "editUserInfo.saveError": "सुरक्षित गर्न असफल भयो",
  "editUserInfo.pictureLimit": "तस्वीर २ एमबी भन्दा कम हुनुपर्छ",
  "editUserInfo.uploadPicture": "प्रोफाइल तस्वीर अपलोड गर्नुहोस्",
  "editUserInfo.picturePreview": "पूर्वावलोकन",

  "editUserInfo.bindPhoneNumber": "फोन नम्बर बाँध्नुहोस्",
  "editUserInfo.bindEmail": "इमेल बाँध्नुहोस्",
  "editUserInfo.changePassword": "पासवर्ड परिवर्तन गर्नुहोस्",

  "editUserInfo.notificationSettings": "सूचना सेटिङ्हरू",
  "editUserInfo.editAccount": "प्रयोगकर्ता खाता जानकारी सम्पादन गर्नुहोस्",
  "editUserInfo.waitBingting": "बाँध्दै, कृपया पर्खनुहोस्...",
  "editUserInfo.collapse": "बन्द गर्नुहोस्",
  "editUserInfo.modifyBinding": "बाँध्ने परिवर्तन गर्नुहोस्",

  "editUserInfo.emailAddress": "इमेल ठेगाना",
  "editUserInfo.tips1": "इमेल बाँध्न सफल भयो",
  "editUserInfo.tips2": "सुरक्षित गर्न असफल भयो",
  "editUserInfo.tips3": "इमेल सत्यापन कोड पठाउँदै, कृपया पर्खनुहोस्...",
  "editUserInfo.tips4": "सत्यापन कोड इमेल xxxx मा पठाइएको छ, कृपया जाँच गर्नुहोस्",
  "editUserInfo.tips5": "सत्यापन कोड पठाउन असफल भयो!",
  "editUserInfo.tips6": "पहिले नै फोन नम्बर बाँधिएको छ",
  "editUserInfo.tips7": "पहिले नै इमेल बाँधिएको छ",
  "editUserInfo.emailTips1": "कृपया इमेल ठेगाना भर्नुहोस्",
  "editUserInfo.emailTips2": "इमेल ठेगाना ढाँचा गलत छ",
  "editUserInfo.emailTips3": "xxxx सेकेन्डपछि फेरी पठाउन सकिन्छ",
  "editUserInfo.emailTips4": "कोड पठाउनुहोस्",
  "editUserInfo.emailTips5": "इमेल सत्यापन कोड खाली हुनुहुन्न",
  "editUserInfo.emailTips6": "इमेल सत्यापन कोड गलत छ",
  "editUserInfo.emailCode": "इमेल सत्यापन कोड",
  "editUserInfo.save": "सुरक्षित गर्नुहोस्",

  "editUserInfo.phoneTips1": "मोबाइल नम्बर बाँध्न सफल भयो",
  "editUserInfo.phoneTips2": "एसएमएस सत्यापन कोड पठाउँदै, कृपया पर्खनुहोस्...",
  "editUserInfo.phoneTips3": "एसएमएस सत्यापन कोड फोन xxxx मा पठाइएको छ, कृपया जाँच गर्नुहोस्",
  "editUserInfo.phoneTips4": "एसएमएस सत्यापन कोड पठाउन असफल भयो!",
  "editUserInfo.phoneTips5": "कृपया फोन नम्बर भर्नुहोस्",
  "editUserInfo.phoneTips6": "फोन नम्बर ढाँचा गलत छ",
  "editUserInfo.phoneTips7": "एसएमएस कोड पठाउनुहोस्",
  "editUserInfo.phoneTips8": "एसएमएस सत्यापन कोड",
  "editUserInfo.phoneTips9": "मोबाइल सत्यापन कोड खाली हुनुहुन्न",
  "editUserInfo.phoneTips10": "मोबाइल सत्यापन कोड गलत छ",
  "editUserInfo.phone": "फोन नम्बर",

  "editUserInfo.noticeTips1": "सूचना कन्फिगरेसन प्राप्त गर्न असफल भयो!",
  "editUserInfo.noticeTips2": "सूचना सेटिङ्हरू सुरक्षित गर्न सफल भयो!",
  "editUserInfo.noticeTips3": "ब्याट्री कम बिजुली सूचना",
  "editUserInfo.noticeTips4": "चार्जिंग स्टेशन चार्ज सकिएको सूचना",
  "editUserInfo.errorNotification": "त्रुटि सूचना",
  "editUserInfo.updateNotification": "अपडेट सूचना",
  "editUserInfo.monthlyStatisticsNotification": "मासिक तथ्याङ्क सूचना",
  "editUserInfo.notificationMethod": "प्राप्त गर्ने विधि",

  "editUserInfo.userNameTips1": "प्रयोगकर्ता नाम सुरक्षित गर्न सफल भयो",
  "editUserInfo.userNameTips2": "प्रयोगकर्ता नाम सुरक्षित गर्न असफल भयो",
  "editUserInfo.userNameTips3": "कृपया प्रयोगकर्ता नाम भर्नुहोस्",
  "editUserInfo.userNameTips4": "प्रयोगकर्ता नाम ढाँचा गलत छ, अंक अण्डरस्कोर अंग्रेजी बाट बनेको हुनुपर्छ",
  "editUserInfo.userNameTips5": "कृपया प्रयोगकर्ता नाम भर्नुहोस्",
  "editUserInfo.userNameTips6": "सुरक्षित गर्दै, कृपया पर्खनुहोस्...",
  "editUserInfo.userName": "प्रयोगकर्ता नाम",

  "editUserInfo.avatorTips": "प्रोफाइल तस्वीर परिवर्तन गर्न क्लिक गर्नुहोस्",
  "editUserInfo.verifyCodeTips1": "कृपया तपाइँले प्राप्त गर्नुभएको सत्यापन कोड भर्नुहोस्:",
  "editUserInfo.verifyCodeTips2": "तपाइँको खाता सुरक्षाको लागि, कृपया मोबाइल नम्बरलाई सत्यापन कोड पठाउन तलको बटन क्लिक गर्नुहोस्:",
  "editUserInfo.verifyCodeTips3": "कोड पठाउनुहोस्",
  "editUserInfo.verifyCodeTips4": "पुरानो मोबाइल सत्यापन सफल भयो, कृपया नयाँ बाँध्ने मोबाइल नम्बर भर्नुहोस्",
  "editUserInfo.verifyCodeTips5": "तपाइँको खाता सुरक्षाको लागि, कृपया इमेललाई सत्यापन कोड पठाउन तलको बटन क्लिक गर्नुहोस्:",
  "editUserInfo.verifyCodeTips6": "पुरानो इमेल सत्यापन सफल भयो, कृपया नयाँ इमेल भर्नुहोस्",
  "editUserInfo.verifyCodeTips7": "पुरानो पासवर्ड",
  "editUserInfo.verifyCodeTips8": "कृपया पहिले इमेल बाँध्नुहोस्!",
  "editUserInfo.verifyCodeTips9": "सत्यापन कोड इमेलमा पठाइएको छ, कृपया इमेल जाँच गर्नुहोस्",
  "editUserInfo.verifyCodeTips10": ", स्वत: लगइन पृष्ठमा रिडाइरेक्ट हुनेछ",

  "hems.notice.title": "सूचना शीर्षक",
  "hems.notice.content": "सूचना सामग्री",
  "hems.notice.operate": "सञ्चालन",
  "hems.notice.noRead": "नपढिएको",
  "hems.notice.read": "पढिसकिएको",
  "hems.notice.warning": "सचेतना",
  "hems.notice.error": "त्रुटि",
  "hems.notice.success": "तथ्याङ्क निपटान",
  "hems.notice.sys": "सिस्टम जानकारी",
  "hems.notice.operateSuccess": "सञ्चालन सफल भयो",
  "hems.notice.operateTips": "कृपया सञ्चालन गर्न आइटमहरू चयन गर्नुहोस्",

  "hems.home.selfuseRate": "स्वतः उपयोग दर",
  "hems.home.percent": "प्रतिशत",
  "hems.home.todayData": "आजको डाटा",
  "hems.home.todayPowerGeneration": "आजको बिजुली उत्पादन",
  "hems.home.salesIncome": "बिजुली बिक्री आय",
  "hems.home.saved": "ले तपाइँको बचत गर्यो",
  "hems.home.reduce": "कार्बन फुटप्रिन्ट कम गर्नुहोस्",
  "hems.home.tips1": "अहिले कुनै डाटा छैन, तपाइँले अझै xxxx बाँध्नुभएको छैन",
  "hems.home.criticalLoad": "महत्वपूर्ण लोड",
  "hems.home.keyVoltage": "महत्वपूर्ण भोल्टेज",
  "hems.home.householdLoad": "घरायसी लोड",
  "hems.home.householdVoltage": "घरायसी भोल्टेज",
  "hems.home.generalLoad": "सामान्य लोड",
  "hems.home.generalVoltage": "सामान्य भोल्टेज",
  "hems.home.batteryHealth": "ब्याट्री स्वास्थ्य",
  "hems.home.averageTemp": "औसत तापक्रम",
  "hems.home.gridLoad": "ग्रिड लोड",
  "hems.home.toggeleDataSource": "हाल प्रदर्शन डाटा परिवर्तन भयो:",
  "hems.home.toggleTips": "तपाइँ निश्चित रूपमा परिवर्तन गर्न चाहनुहुन्छ?",
  "hems.home.modeSending": "मोड निर्देशन पठाउँदै, कृपया पर्खनुहोस्...",
  "hems.home.modeSuccess": "मोड स्विच निर्देशन सफलतापूर्वक पठाइयो!",
  "hems.home.isOnline": "अनलाइन छ कि छैन",
  "hems.home.useStatus": "प्रयोग स्थिति",
  "hems.home.workModeText": "हालको काम मोड:",
  "hems.home.toggleDataSourceText": "हाल प्रदर्शन डाटा परिवर्तन भयो:",
  "hems.ev.charge.status": "चार्ज स्थिति",
  "hems.ev.charge.time": "चार्ज अवधि",
  "hems.ev.charge.count": "वास्तविक समय चार्ज मात्रा",
  "hems.ev.charge.status.empty": "खाली",
  "hems.ev.charge.status.ing": "चार्ज गर्दै",
  "hems.ev.charge.status.null": "प्लग गरिएको तर चार्ज छैन",
  "hems.ev.charge.status.error": "त्रुटि",
  "hems.hour": "घण्टा",
  "hems.minue": "मिनेट",
  "hems.ev.chagre.number": "चार्जिंग स्टेशन नम्बर",

  "hems.userGuide.selfUse": "स्वतः उत्पादन र स्वतः उपयोग",
  "hems.userGuide.selfUseTips": "सौर्य बिजुली प्राथमिकता प्रयोग गर्नुहोस्, अपर्याप्त भएमा ग्रिडबाट पूरक गर्नुहोस्",
  "hems.userGuide.economyMode": "आर्थिक मोड",
  "hems.userGuide.economyModeTips": "बिजुली दर अनुसार बिजुली प्रयोग रणनीति अनुकूलन गर्नुहोस्",
  "hems.userGuide.emergencyMode": "आपतकालीन मोड",
  "hems.userGuide.emergencyModeTips": "महत्वपूर्ण लोड बिजुली आपूर्ति सुनिश्चित गर्न प्राथमिकता दिनुहोस्",

  "hems.history.energyStatistics": "ऊर्जा तथ्याङ्क",
  "hems.history.revenueStatistics": "आय तथ्याङ्क",
  "hems.history.greenStatistics": "हरियाली उत्सर्जन कमी",
  "hems.history.revenueTitle": "कुल बिजुली बिक्री आय",
  "hems.history.savingsTitle": "कुल बचत",
  "hems.history.carbonTitle": "कुल कार्बन उत्सर्जन कमी",
  "hems.history.day": "दिन",
  "hems.history.month": "महिना",
  "hems.history.year": "वर्ष",
  "hems.history.beforeDay": "अघिल्लो दिन",
  "hems.history.afterDay": "पछिल्लो दिन",
  "hems.history.beforeMonth": "अघिल्लो महिना",
  "hems.history.afterMonth": "पछिल्लो महिना",
  "hems.history.beforeYear": "अघिल्लो वर्ष",
  "hems.history.afterYear": "पछिल्लो वर्ष",
  "hems.history.totalUse": "कुल प्रयोग",
  "hems.history.fullScreen": "पूर्ण स्क्रिन",
  "hems.history.timeSelect": "मिति चयन",
  "sync.tips1": "डाटा सिङ्क निर्देशन सफलतापूर्वक पठाइयो!",
  "sync.tips2": "डाटा सिङ्क चलिरहेको छ, डाटा ठूलो मात्राको कारण, सिङ्क प्रक्रियामा केही समय लाग्न सक्छ, कृपया आधा घण्टापछि फेरी जाँच गर्नुहोस्~",
  "sync.tips3": "उपकरण डाटा सिङ्कमा ढिला हुन सक्छ, यदि डाटा असामान्य देखिन्छ भने, कृपया क्लिक गर्नुहोस्:",
  "sync.tips4": "डाटा सिङ्क गर्नुहोस्",

  "charge.info": "चार्जिंग स्टेशन जानकारी",
  "news.loading": "लोड हुँदैछ...",
  "news.noMore": "थप छैन",
  "hems.pv.power": "सौर्य बिजुली आपूर्ति",

  "ueh.sellPower": "बिजुली बिक्री मात्रा",

  "menu.home": "गृहपृष्ठ",
  "menu.history": "इतिहास डाटा",
  "menu.device": "उपकरण",
  "menu.settings": "सेटिङ्हरू",
  "menu.messageCenter": "सन्देश केन्द्र",
  "menu.help": "मद्दत र समर्थन",
  "menu.mine": "मेरो",

  "mine.userSetting": "प्रयोगकर्ता सेटिङ्हरू",
  "mine.terminalSetting": "टर्मिनल आधारभूत सेटिङ्हरू",
  "mine.uploadCloud": "डाटा क्लाउड ब्याकअपमा अपलोड गर्नुहोस्",
  "mine.changeVersion": "अपडेट जाँच गर्नुहोस्",
  "mine.language": "भाषा परिवर्तन गर्नुहोस्",
  "mine.about": "बारेमा",
  "mine.feedback": "राय र प्रतिक्रिया",
  "mine.logout": "लगआउट गर्नुहोस्",
  "mine.logoutAccount": "खाता मेटाउनुहोस्",

  "mine.logoutAccountTips": "नाम [] भएको खाता मेटाउनुहोस्",
  "mine.logoutAccountTips1": "[] बाँधिएको खाता मेटाउनुहोस्",
  "mine.logoutAccountCare": "खाता मेटाउन सम्बन्धित कुराहरू:",
  "mine.logoutAccountCare1": "१. खाता सुरक्षित स्थितिमा छ",
  "mine.logoutAccountCare1-1": "खाता हाल सामान्य प्रयोग स्थितिमा छ, चोरी, अनियमित, अक्षम आदि जोखिम छैन।",
  "mine.logoutAccountCare2": "२. खाता अधिकार, बाँध्ने सम्बन्ध हटाइएको छ",
  "mine.logoutAccountCare2-1": "खाता अन्य तेस्रो पक्ष प्लेटफर्महरूसँगको अधिकार आदि हटाइएको छ।",
  "mine.logoutAccountCare3": "३. खाता मेटाएपछि फेरी प्राप्त गर्न सकिँदैन, प्रयोगकर्ता डाटा हटाइन्छ",
  "mine.logoutAccountCare3-1": "खाता मेटाएपछि, बाँधिएको मोबाइल र इमेल आदि खाता र सम्बन्धित डाटा, सबै हटाइन्छ फेरी प्राप्त गर्न सकिँदैन।",
  "mine.confirmLogout": "मेटाउन पुष्टि गर्नुहोस्",
  "mine.logoutSuccess": "खाता मेटाउन सफल भयो!",

  "mine.feedbackIssues": "समस्याहरू प्रतिक्रिया दिनुहोस्",
  "mine.feedQuantity": "मात्रा",
  "mine.feedAmount": "अधिकतम ९ वटा तस्वीर, अधिकतम १ एमबी/तस्वीर",

  "mine.notice.fail": "सूचना कन्फिगरेसन प्राप्त गर्न असफल भयो!",
  "mine.notice.saveSuccess": "सूचना सेटिङ्हरू सुरक्षित गर्न सफल भयो!",
  "mine.notice.saveFail": "सुरक्षित गर्न असफल भयो!",
  "mine.notice.title": "सूचना सेटिङ्हरू",
  "mine.notice.batteryLow": "ब्याट्री कम बिजुली सूचना",
  "mine.notice.chargingFinish": "चार्जिंग स्टेशन चार्ज सकिएको सूचना",
  "mine.notice.error": "त्रुटि सूचना",
  "mine.notice.update": "अपडेट सूचना",
  "mine.notice.monthly": "मासिक तथ्याङ्क सूचना",
  "mine.notice.receiveType": "प्राप्त गर्ने प्रकार",

  "mine.language.welcome": "SusprSafe मा स्वागत छ",
  "mine.language.desc1": "कृपया तपाइँको क्षेत्र अनुसार भाषा संस्करण सेट गर्नुहोस्",
  "mine.language.desc2": "तपाइँ एप्लिकेसनको सेटिङ्हरू मार्फत कुनै पनि समयमा परिवर्तन गर्न सक्नुहुन्छ",

  "mine.userInfo.avatar": "प्रोफाइल तस्वीर",
  "mine.userInfo.nickname": "उपनाम",
  "mine.userInfo.password": "पासवर्ड",
  "mine.userInfo.changePassword": "पासवर्ड परिवर्तन गर्नुहोस्",
  "mine.userInfo.setPassword": "पासवर्ड सेट गर्नुहोस्",
  "mine.userInfo.phoneNumber": "फोन नम्बर",
  "mine.userInfo.bindPhone": "फोन नम्बर बाँध्नुहोस्",
  "mine.userInfo.bindEmail": "इमेल बाँध्नुहोस्",
  "mine.loginExpired": "लगइन म्याद सकियो, कृपया फेरी लगइन गर्नुहोस्",
  "mine.userInfo.title": "प्रयोगकर्ता जानकारी",
  "mine.userInfo.bind": "बाँध्नुहोस्",
  "mine.userInfo.modify": "परिवर्तन गर्नुहोस्",
  "mine.userInfo.modifyNickname": "उपनाम परिवर्तन गर्नुहोस्",
  "mine.userInfo.userNickname": "प्रयोगकर्ता उपनाम",
  "mine.userInfo.selectPic": "कृपया अपलोड गर्ने तस्वीर चयन गर्नुहोस्",
  "mine.userInfo.saveSuccess": "सुरक्षित गर्न सफल भयो",
  "mine.userInfo.uploadFail": "अपलोड गर्न असफल भयो",
  "mine.userInfo.avatarSaveSuccess": "प्रोफाइल तस्वीर सुरक्षित गर्न सफल भयो",
  "mine.userInfo.nameTips1": "प्रयोगकर्ता उपनाम खाली हुनुहुन्न",
  "mine.userInfo.nameTips2": "कृपया प्रयोगकर्ता उपनाम भर्नुहोस्",

  "common.pleaseSelect": "कृपया चयन गर्नुहोस्",
  "question.commonQuestions": "सामान्य प्रश्नहरू",
  "account.toggleLanguage": "भाषा परिवर्तन गर्नुहोस्",
  "account.localConnection": "स्थानिय जडान",
  "account.selectLanguage": "कृपया भाषा चयन गर्नुहोस्",
  "account.sendEmailToast": "सत्यापन कोड इमेल xxx मा पठाइएको छ, कृपया इमेल जाँच गर्नुहोस्",
  "account.emailError": "इमेल ढाँचा गलत छ",
  "account.sendEmailFail": "पठाउन असफल भयो, कृपया फेरी प्रयास गर्नुहोस्",

  "common.submitting": "पेश गर्दै, कृपया पर्खनुहोस्...",

  "device.page.noData": "अहिले कुनै डाटा छैन, यो पृष्ठ एपमा मात्र हेर्न सकिन्छ",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
}